import React, { useEffect, useState } from "react";
import { useCallback, useContext } from "react";
import { useDropzone } from "react-dropzone";
import { PageContext } from "../../App";
import { generateRandomString } from "../Utils";
import mime from "mime";
import { ScrollRestoration } from "react-router-dom";

//extended file object to include path
//for files imported from google drive
//as those file does not have path attribute
//we have used path attributes as key for out app
//so it is a must have attribute
export class ExtendedFile extends File {
  constructor(blob, name, fileOptions) {
    //super class
    super(blob, name, fileOptions);

    //set path
    this.path =
      this.path ??
      `./${generateRandomString(10)}_${name}.${mime.getExtension(fileOptions.type)}`;
  }
}

function MiscUploadPDFView(props) {
  //get context
  const { setSelectedFiles, startProcessingFiles, setStartProcessingFiles } =
    useContext(PageContext);

  //is loading google drive files
  const [loadingExternalFiles, setLoadingExternalFiles] = useState({
    loading: false,
    message: "",
  });

  //scroll to top
  const [scrollToTop, setScrollToTop] = useState(false);

  //callback on picked file
  const onPickedDriveFiles = (docs, access_token) => {
    //count
    let count = docs.length ?? 0;
    //files array
    let files = [];

    //set
    setLoadingExternalFiles({
      ...loadingExternalFiles,
      loading: true,
      message: "5%",
    });
    //loop
    docs.forEach(async (item) => {
      //download file
      await getFileFromGoogleDrive(item.id, access_token, (blob) => {
        //decrement
        count = count - 1;
        // Optional: Create a JavaScript File object from the blob for easier handling (e.g., for uploads)
        const fileOptions = {
          type: item.mimeType,
        };
        //create file object
        const file = new ExtendedFile([blob], item.name, fileOptions);
        //add file to list
        files.push(file);

        //set progress
        setLoadingExternalFiles({
          ...loadingExternalFiles,
          loading: true,
          message: `${Math.floor(((docs.length - count) / docs.length) * 100)}%`,
        });

        //check
        if (count === 0) {
          //stop progress
          //set array
          //check
          if (files.length > 0) {
            //set files
            setSelectedFiles(files);
            //start uploading
            setStartProcessingFiles(true);
            //set
            setLoadingExternalFiles({
              ...loadingExternalFiles,
              loading: false,
              message: "",
            });
          }
        }
      });
    });
  };

  //use effect
  useEffect(() => {
    //register function
    // Expose the function to the global window object
    window.onPickedDriveFiles = onPickedDriveFiles;

    // Optional: Clean up the global function when the component unmounts
    return () => {
      delete window.onPickedDriveFiles;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //dropped files
  const onDrop = useCallback(
    (selectedFiles) => {
      //set files
      setSelectedFiles(selectedFiles);
      //start uploading
      setStartProcessingFiles(true);

      // Do something with the files
      console.log("files: ", selectedFiles);
    },
    // eslint-disable-next-line
    [setSelectedFiles, startProcessingFiles],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: props.filetype,
    multiple: props.selectMultiple ?? false,
    useFsAccessApi: (props.allowFolder ?? false) ? false : true, // Disable the File System Access API
  });

  //mime types
  //seperate by , for multiple mime types
  const mimeTypes = () => {
    //return
    return props.filetype === undefined
      ? null
      : Object.keys(props.filetype).reduce(
          (accumulator, currentValue) => accumulator + currentValue + ",",
          "", // Initial value of the accumulator
        );
  };

  //download file from google drive
  const getFileFromGoogleDrive = async (fileId, accessToken, callback) => {
    //drive url to download file
    const URL = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;

    //fetch the status from the API
    await fetch(URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`, // if needed
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        console.log("Response Data: ", blob);
        //return
        callback(blob); // or return the raw blob if a File object isn't needed
      })
      .catch((error) => {
        console.error("Error:", error);
        //return
        callback(null);
      });
  };

  return (
    <div className="container mt-5">
      {/* scroll to top, as often page scrolls to bottom */}
      {scrollToTop && <ScrollRestoration />}
      {/* Overlay Container rect */}
      <div className="position-relative">
        {/* Lower layer rect */}
        <div
          className="bg-primary rounded-2 pt-4 pb-5"
          style={{ height: "350px" }}
          {...getRootProps()}
        >
          {/* Overlay dotted rect */}
          <div
            className="position-absolute bg-transparent m-2 rounded-2"
            style={{
              left: "0px",
              right: "0px",
              margin: "auto",
              top: "0px",
              bottom: "0px",
              borderStyle: "dashed",
              borderColor: "#ffffff",
              borderWidth: "1px",
            }}
          ></div>

          {/* center button containers */}
          <div
            className="position-absolute"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
            }}
          >
            {/* Image */}
            <div className="text-center">
              <img
                loading="lazy"
                src="./images/pdf_file.png"
                alt="pdf document"
                style={{ width: "80px", height: "80px" }}
              />
            </div>

            {/* Drag and drop text */}
            <div className="text-center">
              <label className="mt-1 text-light fs-4 mb-3">
                {isDragActive ? "drop here" : "drag and drop files here or"}
              </label>
            </div>

            {/* Button */}
            <div className="justify-content-center text-center ps-5">
              {/* On click open file select menu */}
              {props.allowFolder ? (
                <input
                  {...getInputProps({
                    webkitdirectory: "true", // Enable folder selection
                    mozdirectory: "true", // For Firefox compatibility (optional)
                    directory: "true", // For general compatibility (optional)
                  })}
                />
              ) : (
                <input {...getInputProps()} />
              )}

              {/* Choose Files Button */}
              <button
                type="button"
                className="btn btn-light fw-bold fs-6 border px-5 py-3"
                style={{ backgroundColor: "#ffffff" }}
              >
                <img
                  loading="lazy"
                  className="me-3"
                  src="./images/file_icon.png"
                  alt="pdf document"
                  style={{ width: "30px", height: "30px" }}
                />
                CHOOSE FILES
              </button>

              {/*Google Drive*/}
              <button
                type="button"
                className="ms-2 btn mt-2 mt-sm-0"
                onClick={(e) => {
                  //check
                  //if loading files
                  //disable click
                  if (loadingExternalFiles.loading) {
                    //return
                    return;
                  }

                  //stop click propagarion
                  //otherwise file select menu will pop up
                  e.stopPropagation();
                  //blur
                  e.currentTarget.blur();

                  // Call the globally exposed function
                  if (window.createDrivePickerPicker) {
                    //try catch
                    try {
                      //open drive picker
                      window.createDrivePickerPicker(
                        (props.selectMultiple ?? false) ? 10 : 1,
                        mimeTypes(),
                        (props.selectMultiple ?? false)
                          ? "Select 10 files"
                          : "Select 1 file",
                      );
                      //scroll to top
                      setScrollToTop(true);
                    } catch (e) {
                      console.log("Error: ", e);
                    }
                  } else {
                    console.log("createDrivePickerPicker function not found");
                  }

                  console.log("Open google drive");
                }}
              >
                <div>
                  {/* Image */}
                  <img
                    loading="lazy"
                    className="me-3"
                    src="./images/google_drive.png"
                    alt="pdf document"
                    style={{ width: "30px", height: "30px" }}
                  />
                  {/* label */}
                  {/* Show loading title if showing google picker */}
                  {/* Else show default title */}
                  <label className="text-white" style={{ cursor: "pointer" }}>
                    {loadingExternalFiles.loading
                      ? loadingExternalFiles.message
                      : "Google Drive"}
                  </label>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MiscUploadPDFView;
